import validate from "/opt/render/project/src/node_modules/.pnpm/nuxt@4.0.3_@netlify+blobs@8.2.0_@parcel+watcher@2.5.1_@types+node@22.15.21_@vue+compile_215386922af35afe059e9f8174f699ed/node_modules/nuxt/dist/pages/runtime/validate.js";
import manifest_45route_45rule from "/opt/render/project/src/node_modules/.pnpm/nuxt@4.0.3_@netlify+blobs@8.2.0_@parcel+watcher@2.5.1_@types+node@22.15.21_@vue+compile_215386922af35afe059e9f8174f699ed/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  manifest_45route_45rule
]
export const namedMiddleware = {}